import { trackEvent } from "@/utils/analytics";

export const trackNewsPageViewed = (): void => {
  trackEvent("news.page_viewed", {
    category: "News",
    action: "page_viewed",
  });
};

interface NewsCardClickParams {
  resourceType: string;
  resourceUuid: string;
}

export const trackNewsCardClick = (params: NewsCardClickParams): void => {
  trackEvent("news.news_card_clicked", {
    category: "News Discovery",
    action: "news_card_clicked",
    resource_type: params.resourceType,
    resource_uuid: params.resourceUuid,
  });
};

export const trackNewsFiltersChanged = (): void => {
  trackEvent("news.news_filters_changed", {
    category: "News Filters",
    action: "news_filters_changed",
  });
};

interface NewsDetailsViewParams {
  resourceType: string;
  resourceUuid: string;
}

export const trackNewsDetailsView = (params: NewsDetailsViewParams): void => {
  trackEvent("news.news_details_viewed", {
    category: "News Details",
    action: "news_details_viewed",
    resource_type: params.resourceType,
    resource_uuid: params.resourceUuid,
  });
};
